import { logout, getLoginUserInfo, getUserMenu } from '@/frameworks/api/login'
import { getToken, setToken, removeToken } from '@/common/utils/auth'
import tokenService from '@/frameworks/auths/tokenService'
import { Message } from 'win-design'

const user = {
  state: {
    status: '',
    code: '',
    token: getToken(),
    roles: [],
    menus: [],
    loginUserInfo: {
      username: '',
      userDisplayName: '',
      UserId: '',
      avatar: '',
      introduction: ''
    },
    HospitalCode: null,
    orgList: [],
    ZKZList: [],
    RedirectUrl: '',
    VersionInfo: ''
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.loginUserInfo.introduction = introduction
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_NAME: (state, name) => {
      state.loginUserInfo.userDisplayName = name
    },
    SET_AVATAR: (state, avatar) => {
      state.loginUserInfo.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus
    },
    SET_LOGIN_USER_INFO: (state, userInfo) => {
      // 存储当前进入系统的日期.
      userInfo.loginDate = new Date()
      state.loginUserInfo = userInfo
    },
    SET_USERNAME: (state, loginName) => {
      state.loginUserInfo.username = loginName
    },
    SET_ORG_list: (state, orgList) => {
      state.orgList = orgList
    },
    SET_ZKZ_list: (state, ZKZList) => {
      state.ZKZList = ZKZList
    },
    SET_VERSION: (state, VersionInfo) => {
      state.VersionInfo = VersionInfo
    },
    SET_REDIRECT_URL: (state, RedirectUrl) => {
      state.RedirectUrl = RedirectUrl
    },
    SET_HOSPITAL_CODE: (state, HospitalCode) => {
      state.HospitalCode = HospitalCode
    }
  },

  actions: {
    // 获取用户信息
    GetLoginUserInfo({ commit, state, dispatch }, params) {
      return new Promise((resolve, reject) => {
        getLoginUserInfo(params)
          .then((res) => {
            /**
             * data:
             * UserName 用户id
             * userDisplayName 用户显示名
             * loginUserToken 登录后的token信息
             * navMenus 用户可访问菜单
             */
            if (res.success) {
              const menuDtoList = res.data.MenuInfo || []
              let baseUrl = window.globalConfig.BaseUrl
              let isProductMode = window.globalConfig.isProductMode

              if (isProductMode) {
                res.data.MenuInfo.forEach((item) => {
                  item.Children.forEach((c) => {
                    if (c.SFQT == '1') {
                      c.URL = baseUrl.substr(0, baseUrl.length - 1) + c.URL
                    }
                  })
                })
              }
              // commit("SET_ROLES", roles);
              commit('SET_MENUS', menuDtoList)
              commit(
                'SET_REDIRECT_URL',
                res.data.IsRedirect === '1' ? res.data.RedirectUrl : ''
              )
              commit('SET_USERNAME', res.data.User.NAME)
              commit('SET_NAME', res.data.User.NAME)
              let userInfo = res.data.User
              userInfo.UserId = userInfo.ID
              userInfo.username = userInfo.NAME || userInfo.ID

              commit('SET_LOGIN_USER_INFO', res.data.User)
              commit('SET_ORG_list', res.data.RightOrgList)
              commit('SET_ZKZ_list', res.data.RightZKZList)
              commit('SET_VERSION', res.data.VersionInfo)
              dispatch('initNavmenus', menuDtoList).then((menus) => {
                resolve({
                  userInfo: res.data.User,
                  menus,
                  success: res.success
                })
              }) // 动态修改权限后 重绘侧边菜单
              // commit("SET_AVATAR", "./static/avatar.gif");
            } else {
              // Message({
              //   message: res.message,
              //   type: 'error',
              //   duration: 5 * 1000
              // })
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    // 获取用户菜单
    GetUserMenu({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        getUserMenu({ syscode: 'NQC', UserId: '000' })
          .then((data) => {
            /**
             * navMenus 用户可访问菜单
             */
            const menuDtoList = data.data || []
            // const menus = menuDtoList.map(function (item, key, ary) {
            //   return item.funcCode
            // })
            commit('SET_MENUS', menuDtoList)
            dispatch('initNavmenus', menuDtoList).then((menus) => {
              resolve({ userInfo: data, menus })
            })
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            removeToken()
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user
